module.exports = __webpack_public_path__ + "static/bad-ux-toothbrush-e771aaba797a5580d3be3a44aff97482.png";